import { render, staticRenderFns } from "./HandlerSound.vue?vue&type=template&id=5a67f330&scoped=true&"
import script from "./HandlerSound.vue?vue&type=script&lang=js&"
export * from "./HandlerSound.vue?vue&type=script&lang=js&"
import style0 from "./HandlerSound.vue?vue&type=style&index=0&id=5a67f330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a67f330",
  null
  
)

export default component.exports